import React, { useState } from "react";
import Logo from "../../assets/images/logo/logo.png";
import Chat from "../../assets/images/icon/chat.png";
import Education from "../../assets/images/icon/Education.png";
import Lock1 from "../../assets/images/icon/Lock1.png";
import User from "../../assets/images/icon/user.png";
import Password from "../../assets/images/icon/Lock2.png";
import Lock from "../../assets/images/icon/Access.png";
import { useNavigate } from "react-router-dom";
import LoginAnimation from "../../components/LoginAnimation";
import { useFormik } from "formik";
import * as Yup from "yup";
import AuthService from "../../services/auth";
import { toastError, toastSuccess } from "../../components/ToastNotification";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../store/slices/userSlice";
const SignUp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isShow, setIsShow] = useState(false);
  const [isSubmiting, setSubmiting] = useState(false);

  const initialValues = {
    username: "",
    password: "",
    confirmPassword: "",
  };

  const validationSchema = Yup.object({
    username: Yup.string().required("Email is required"),
    password: Yup.string()
      .min(8, "Password must be at least 8 characters")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
  });

  const handleSubmit = async (values) => {
    try {
      setSubmiting(true);
      const response = await AuthService?.signup(
        values?.username,
        values.password
      );
      if (response) {
        setIsShow(true);
        setTimeout(() => {
          setIsShow(false);
          toastSuccess(response?.data?.message || "Register successfully!");
          localStorage.setItem("linko_admin", response?.data?.token);
          dispatch(setUser(response?.data?.data));
          navigate("/user-admin");
        }, 1000);
      }
    } catch (error) {
      toastError(error?.response?.data?.message);
    } finally {
      setSubmiting(false);
      // setIsLoading(false);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  return (
    <>
      {isShow ? (
        <LoginAnimation />
      ) : (
        <div className="lg:grid lg:grid-cols-2 h-screen items-center">
          <div className="flex flex-col justify-center items-center lg:hidden h-52">
            <div className="h-10 sm:h-16 w-[100px] sm:w-auto mx-auto">
              <img src={Logo} alt="Logo" className="h-full w-full" />
            </div>
            <h1 className="text-2xl max-w-xl text-center mx-auto time px-3">
              Tu asistente privado de traducción.
            </h1>
          </div>
          <div className="bg-white h-full max-lg:hidden grid items-center">
            <div className="grid gap-14 items-center justify-center">
              <div className="h-20 w-fit mx-auto">
                <img src={Logo} alt="Logo" className="h-full w-full" />
              </div>
              <h1 className="text-6xl max-w-xl text-center mx-auto time">
                Tu asistente privado de traducción.
              </h1>
              <div>
                <div className="max-w-md mx-auto xl:px-10 grid gap-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 flex justify-center">
                      <img src={Chat} alt="Chat" className="w-auto h-8" />
                    </div>
                    <p className="text-primary font-semibold text-2xl">
                      : IA DE TRADUCCIÓN
                    </p>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 flex justify-center">
                      <img
                        src={Education}
                        alt="Education"
                        className="w-auto h-8"
                      />
                    </div>
                    <p className="text-primary font-semibold text-2xl">
                      : ENTRENADA PARA TI
                    </p>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-10 flex justify-center">
                      <img
                        src={Lock1}
                        alt="Confidential"
                        className="w-auto h-8"
                      />
                    </div>
                    <p className="text-primary font-semibold text-2xl">
                      : SERVIDOR CONFIDENCIAL
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="background lg:h-full flex items-center p-4 max-lg:h-[calc(100vh-208px)]">
            <div className="flex items-center justify-center bg-secondery max-w-lg mx-auto w-full rounded-[25px]">
              <div className="p-4 sm:p-6 lg:p-14 w-full max-lg:py-10">
                <div className="mb-10 flex flex-col justify-center items-center lg:hidden">
                  <div className="h-10 sm:h-16 w-fit mx-auto">
                    <img src={Logo} alt="Logo" className="h-full w-full" />
                  </div>
                  <h1 className="text-2xl max-w-xl text-center mx-auto time">
                    Tu asistente privado de traducción.
                  </h1>
                </div>
                <form onSubmit={formik.handleSubmit}>
                  <div className="grid gap-2">
                    <div className="flex gap-4">
                      <div className="h-8 w-8 min-w-10 min-h-10 bg-white rounded-full border border-primary flex items-center justify-center">
                        <img src={User} alt="User Icon" />
                      </div>
                      <div className="w-full">
                        <input
                          type="email"
                          name="username"
                          className="input-control border !border-primary shadow-input !bg-white"
                          placeholder="Email"
                          value={formik.values.username}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.username && formik.errors.username && (
                          <div className="text-red-500 text-sm">
                            {formik.errors.username}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="flex gap-4 mt-4">
                      <div className="h-8 w-8 min-w-10 min-h-10 bg-white rounded-full border border-primary flex items-center justify-center">
                        <img
                          src={Password}
                          alt="Password Icon"
                          className="w-7 h-7"
                        />
                      </div>
                      <div className="w-full">
                        <input
                          type="password"
                          name="password"
                          className="input-control border !border-primary shadow-input !bg-white"
                          placeholder="Password"
                          value={formik.values.password}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.password && formik.errors.password && (
                          <div className="text-red-500 text-sm">
                            {formik.errors.password}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="flex gap-4 mt-4">
                      <div className="h-8 w-8 min-w-10 min-h-10 bg-white rounded-full border border-primary flex items-center justify-center">
                        <img
                          src={Password}
                          alt="Confirm Password Icon"
                          className="w-7 h-7"
                        />
                      </div>
                      <div className="w-full">
                        <input
                          type="password"
                          name="confirmPassword"
                          className="input-control border !border-primary shadow-input !bg-white"
                          placeholder="Confirm Password"
                          value={formik.values.confirmPassword}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.touched.confirmPassword &&
                          formik.errors.confirmPassword && (
                            <div className="text-red-500 text-sm">
                              {formik.errors.confirmPassword}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-4 mt-10">
                    <div className="h-8 w-8 min-w-10 min-h-10 bg-white rounded-full border border-primary flex items-center justify-center">
                      <img src={Lock} alt="Lock Icon" className="w-7 h-7" />
                    </div>
                    <div className="grid gap-2">
                      <button
                        type="submit"
                        className="input-control !w-44 lg:!w-60 border-2 !border-primary shadow-button font-medium"
                      >
                        {isSubmiting ? (
                          <div className="loaders flex justify-center items-center ml-[86px]"></div>
                        ) : (
                          "SIGN UP"
                        )}
                      </button>
                      <button
                        type="button"
                        className="input-control !w-44 lg:!w-60 border-2 !border-primary shadow-button font-medium"
                        onClick={() => navigate("/login")}
                      >
                        LOGIN
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SignUp;
